export const onThen = (response) => response;
export const onCatch = ({ response }) => response;
